<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="equipe1">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    La fine équipe de Croustillance
                </h1>
            </a></div>
        </full-page>
        <div class="backgroundGreen" id="welcome">
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background:#d7b5b0;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <p style="font-size:35px;font-family: 'Nunito', sans-serif;font-weight: bold">
                                        Le traiteur Croustillance, ça n’est pas seulement une cuisine inventive et
                                        colorée. C’est aussi une savoureuse brochette de cuisiniers et de serveurs,
                                        heureux de vous apporter le meilleur.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Fred-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Fred-traiteur.jpg" alt="Fred le cuisinier"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Fred-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#664f4f;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Frédéric, le chef au piano</h3>
                                    <p>
                                        Frédéric, diplômé de l’École Hôtelière de Namur, a commencé sa carrière chez le
                                        traiteur Loriers, fournisseur de la Couronne de Belgique, il y a plus de 30 ans.
                                        Depuis, il a beaucoup voyagé, et découvert des spécialités très variées à
                                        Bruxelles, à Londres, au Luxembourg, et même… en Lorraine.
                                    </p>
                                    <p>
                                        De cette odyssée, Frédéric a conservé le goût de la cuisine fusion, qui mêle le
                                        meilleur de deux traditions culinaires. Il aime faire se rencontrer au cours
                                        d’un repas de bonnes recettes françaises, belges, indiennes, sud-américaines,
                                        japonaises, etc.
                                    </p>
                                    <p>
                                        Mais qui a donc pu inviter ce généreux cuisinier né en Belgique à poser ses
                                        casseroles dans les Vosges ?
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/equipe/Julie.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/equipe/Julie.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/equipe/Julie.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#ca8086;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Julie, l’artiste dans la salle</h3>
                                    <p>
                                        C’est elle, Julie, qui a eu cette savoureuse idée !
                                    </p>
                                    <p>
                                        D’abord architecte d’intérieur, puis chargée de communication, Julie a profité d’une
                                        pause dans sa carrière pour mijoter avec Frédéric le projet de Croustillance.
                                    </p>
                                    <p>
                                        À partir de 2013, les jeunes associés affinent leurs plans au sein de la <a
                                            href="http://www.pacelor.fr/" class="LinkText" target="_blank">couveuse d'entreprises Pacelor</a>,
                                        avant de créer Croustillance 18 mois plus tard, en mai 2015.
                                    </p>
                                    <p>En 2013, ils s’installent dans leur premier local, rue de la Moselle à Châtel sur Moselle.
                                        Depuis, ils ont beaucoup travaillé, et leur bébé a bien grandi.</p>
                                    <p>Depuis 5 ans, Croustillance s’est installée dans de nouveaux locaux rue de l’Estrey à Nomexy. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/equipe/tarte-citron.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/equipe/tarte-citron.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/equipe/tarte-citron.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/equipe/mille-feuille-legumes.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/equipe/mille-feuille-legumes.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/equipe/mille-feuille-legumes.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/marc-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/marc-cuisinier.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/marc-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#2f2e41;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Marc</h3>
                                    <p>
                                      Cuisinier depuis plus de quarante ans, Marc assure la préparation de l’ensemble des plats pour nos clients du portage à domicile. De l’entrée au dessert, Marc cuisine des mets simples et savoureux adaptés aux goûts de la clientèle : plats en sauce, légumes bien cuits, produits de saison. Marc propose un maximum de produits frais dès que c’est possible : c’est lui qui détient le record de rapidité d’épluchage de la cuisine !
                                    </p>
                                    <p>
                                      Marc est le cuisinier en charge de la réalisation de tous les plats du portage à domicile, il possède une expérience en cuisine de 40 ans en restaurant et en cuisine collective. Originaire de la Région Grand Est, il maîtrise toutes les recettes de notre terroir. Sa nature généreuse se retrouve dans sa cuisine familiale et gourmande !
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Cedric-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Cedric-cuisinier.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Cedric-cuisinier.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#594231;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Cédric, cuisinier</h3>
                                    <p>Cuisinier depuis de nombreuses années, Cédric possède une réelle expérience dans le domaine de la restauration. Véritable cordon bleu ancien propriétaire de son restaurant pendant de nombreuses années, Cédric a enrichi notre équipe de cuisiniers.<br><br>Très pédagogue, il aime encadrer et former les apprentis de l’entreprise avec pédagogie et bienveillance. Gai de nature, il n’est pas rare d’entendre ses grands éclats de rire dans la cuisine ! </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/equipe/terrine-basilic-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/equipe/terrine-basilic-tomate.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/equipe/terrine-basilic-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/poulet-marine.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/poulet-marine.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/poulet-marine.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Catherine-portage-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Catherine-portage-repas.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Catherine-portage-repas.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#ec626b;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Catherine, Livreuse à domicile</h3>
                                    <p>
                                      Cela fait bientôt 7 ans que Catherine travaille chez Croustillance, elle est d’ailleurs la plus ancienne des 10 employés de l’entreprise. Catherine est en charge des livraisons de repas à domicile sur la tournée de Charmes.<br><br>Au fil des années, une véritable complicité s’est nouée avec ses clients qu’elle suit pour certains depuis ses débuts dans l’entreprise. Attentive à leurs besoins et consciente de l’importance de sa présence et de son passage quotidien à leur domicile, Catherine a toujours un petit mot pour chacun.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Sabrina-Denet.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Sabrina-Denet.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Sabrina-Denet.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#45464c;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Sabrina, Livreuse à domicile </h3>
                                    <p>Sabrina livre quotidiennement les plats à nos clients de portage à domicile sur les livraisons de Charmes ou de Golbey. Jeune et dynamique, elle est très appréciée par ses clients à qui elle apporte chaque jour, sa bonne humeur. Sabrina se charge également des livraisons de plateaux repas froids ou chauds aux entreprises.<br><br>Très à l’aise avec les clients, elle assure parfois des missions de service lors des cocktails et des repas assis de Croustillance. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/saumon-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/saumon-tomate.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/saumon-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/sandwitch.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/equipe/sandwitch.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/sandwitch.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Sabina-service-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Sabina-service-table.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Sabina-service-table.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#c28d75;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Sabrina, Livreuse à domicile</h3>
                                    <p>
                                      Cela fait déjà plusieurs années que Sabrina s’occupe de la livraison des repas à domicile pour les personnes âgées. Douce et attentive, elle prend le plus grand soin de nos clients.<br><br>Un petit mot, une plaisanterie, une attention, Sabrina sait que son passage apporte beaucoup de réconfort aux personnes qu’elle rencontre. Et bien entendu, elle leur apporte aussi le repas du jour qui ravira leurs papilles !
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/Lola-cuisiniere.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/Lola-cuisiniere.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/Lola-cuisiniere.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background:#2b2b2b;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Lola, apprentie cuisinière</h3>
                                    <p>Lola est en seconde année de CAP cuisine au lycée Notre Dame Saint Joseph à Épinal. Passionnée par le monde de l’esthétisme, Lola apporte beaucoup de détails à ses préparations culinaires qu’elle conçoit comme une œuvre chargée d’émotions.<br><br>Douce et discrète, elle a su parfaitement su s’intégrer à l’équipe Croustillance où elle apporte sa sensibilité toute féminine. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/dessert-framboise.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="/img/equipe/dessert-framboise.jpg" alt="An image"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('/img/equipe/dessert-framboise.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                        </div>
                    </div>
                </div>

              <div class="row backgroundGreen">
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/pates-chinoises.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="img/equipe/pates-chinoises.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/pates-chinoises.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/Thi-traiteur-asiatique.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/Thi-traiteur-asiatique.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/Thi-traiteur-asiatique.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background:#82062a;">
                  <div class="item media text-white alignLeft">
                    <div class="media-body align-top">
                      <div class="desc">
                        <h3 class="display-6">Thi</h3>
                        <p>
                          Thi a rejoint Croustillance comme stagiaire de la formation professionnelle en préparant un contrat de qualification professionnel de cuisinière au CFA d’Epinal, qu’elle a obtenu brillamment ! <br><br>Elle occupe aujourd’hui un poste de cuisinière, et seconde Marc dans la préparation des plats du portage à domicile. Elle est aussi une aide précieuse dans les forts moments d’activités de l’entreprise où elle donne un coup de main aux différentes préparation des menus de fêtes ou des repas d’entreprise. Elle accompagne souvent le chef de cuisine lors de événements en extérieur pour l’aider lors de l’envoi en cuisine.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row backgroundGreen">
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/France-serveuse.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/France-serveuse.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/France-serveuse.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background:#2b2b2b;">
                  <div class="item media text-white alignLeft">
                    <div class="media-body align-top">
                      <div class="desc">
                        <h3 class="display-6">France, apprentie cuisinière</h3>
                        <p>France est nomexéenne et était ravie de trouver une entreprise aussi proche de chez elle pour réaliser son apprentissage ! Cela ne l’empêche pas de bouger pour suivre sa formation au CFA de Nancy où elle est en première année de CAP cuisine.<br><br>Malgré ses 18 ans, France a déjà de solides connaissances dans le domaine de la vente et du service en salle. Décidée à découvrir un nouveau domaine, celui de la cuisine, nous lui souhaitons d’y découvrir une véritable passion ! </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/oeuf-mayo.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/oeuf-mayo.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/oeuf-mayo.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row backgroundGreen">
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/tarte-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="img/equipe/tarte-tomate.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/tarte-tomate.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/Leo-serveur-restauration.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/Leo-serveur-restauration.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/Leo-serveur-restauration.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background:#561903;">
                  <div class="item media text-white alignLeft">
                    <div class="media-body align-top">
                      <div class="desc">
                        <h3 class="display-6">Léo, apprenti commercial</h3>
                        <p>
                          Léo est en formation au centre de formation de Notre Dame Saint Joseph à Epinal où il prépare un BTS NDRC (Numérisation Digitalisation de la Relation Client), aimant le contact humain il sera ravi de vous aider à trouver la formule correspondante à vos attentes parmi les choix de la carte : buffet, cocktail, menu chaud. Présent sur tous les événements de l’entreprise où il gère l’installation, le service et les équipes, vous le rencontrerez peut-être lors d’un prochain repas !
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row backgroundGreen">
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/Cyril-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/Cyril-traiteur.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/Cyril-traiteur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background:#90acae;">
                  <div class="item media text-white alignLeft">
                    <div class="media-body align-top">
                      <div class="desc">
                        <h3 class="display-6">Cyril, assistant d’événement </h3>
                        <p>Cyril prépare et charge tout le matériel nécessaire à la réalisation des évènements. Véritable maitre dans l’art du Tetris, il sait optimiser le chargement des camions et trouve toujours une solution pour tout casser !<br><br>Vosgien d’origine, hyper impliqué dans le monde associatif et dans sa municipalité, Cyril connait tout le monde et partout ce qui lui permet de converser avec chacun sur les évènements qu’il gère seul ou en collaboration avec le staff Croustillance.  </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4 col-lg-4"
                     style="background-image: url('/img/equipe/burger-vosgien.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                  <div class="item media text-white alignLeft">
                    <div class="media-img">
                      <div class="mask"></div>
                      <img class="img-block" src="/img/equipe/burger-vosgien.jpg" alt="An image"
                           style="display: none;">
                      <div class="img"
                           style="background-image: url('/img/equipe/burger-vosgien.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                    </div>
                  </div>
                </div>
              </div>

                <div class="row backgroundGreen">
                    <div class="col-12 col-md-8 col-lg-8" style="background:#3c2a35;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Sans oublier les extras...</h3>
                                    <p>
                                        Croustillance sert des repas jusqu’à 750 couverts. Alors il en faut, des bras énergiques !
                                    </p>
                                    <p style="font-size:30px;">
                                        Nous remercions Angélique, Émilie, Isabelle, Johanne, Justine, Mariette, Morgane, Nicolas, Paloma, Sophie, Émeline et Sylvie, nos intermittents en cuisine et en salle, pour leur présence essentielle.
                                    </p>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('/img/equipe/equipe-traiteur-croustillance.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'equipe',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Le traiteur Croustillance : une savoureuse brochette de cuisiniers et de serveurs, heureux de vous apporter le meilleur. Nous vous les présentons ici.";
            document.title = " La fine équipe des collaborateurs de Croustillance";
        }
    }
</script>

<style>
    #equipe1 {
        background: url('/img/equipe/equipe-traiteur-croustillance-top.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>